// extracted by mini-css-extract-plugin
module.exports = {"container":"container___27SBe","metaContainer":"metaContainer___3u4lL","des":"des___B_HDN","typo":"typo___3NB8h"};